export class MaterialSearchData {
  id: string;
  category: string;
  type: string;
  source: string;
  catTranslation: string;
  typeTranslation: string;
  sourceTranslation: string;
  fullDisplayName: string;

  constructor(id: string, category: string, type: string, source: string,
              catTranslation: string, typeTranslation: string, sourceTranslation: string
  ) {
    this.id = id;
    this.category = category;
    this.type = type;
    this.source = source;
    this.catTranslation = catTranslation;
    this.typeTranslation = typeTranslation;
    this.sourceTranslation = sourceTranslation;
    this.setFullDisplayName();
  }

  private setFullDisplayName() {
    this.fullDisplayName = this.catTranslation + ', ' + this.typeTranslation + ', ' + this.sourceTranslation;
  }

  isValid(): boolean {
    return !!(this.category && this.type && this.source);
  }
}
